Ext.define('SA.view.sidebar.location.ScarboroughLocationsSidebar', {
    alias: 'widget.scarborough-locations-sidebar',
    extend: 'SA.view.SimpleContainer',

    items: [
        {
            xtype: 'sa-search-field',
            cls: 'sa-sidebar-search-field',
            emptyText: 'Filter',
            favoritesButtonTitle: 'Favorite Locations',
            recentButtonTitle: 'Recent Locations',

            recentList: {
                xtype: 'recent-locations-list',

                favorites: {
                    source: SA.data.FavoriteLocations,
                    title: 'Favorite Locations'
                },

                recent: {
                    source: SA.data.RecentLocations,
                    title: 'Recent Locations'
                }
            }
        }, {
            xtype: 'sidebar-section-header',
            html: 'Scarborough DMA<span style="text-transform: none">s</span>'
        }, {
            xtype: 'sidebar-dma-list'
        }
    ],

    initComponent() {
        this.callParent();

        this.filterField = this.down('sa-search-field');
        this.list = this.down('sidebar-dma-list');
    },

    initEvents() {
        this.callParent();

        this.filterField.on('change', SA.createBuffered(this.onFilterFieldChange, 250), this);
        this.filterField.on('select', this.onSelectDma, this);
        this.list.on('select', this.onSelectDma, this);
    },

    onFilterFieldChange() {
        this.list.setFilterText(this.filterField.getValue());
    },

    onSelectDma(target, locationSeries) {
        this.model.addLocation(locationSeries);

        SA.Sidebar.fireUseItem('use:location', locationSeries);
    },

    refresh() {
        this.list.setSelected(this.model.getLocation());
    },

    setView(view) {
        Ext.destroyMembers(this, 'listener');

        if (view.getType() !== 'scarboroughCrosstab') {
            this.model = null;

            return;
        }

        this.model = view;

        this.listener = this.mon(this.model, 'change:location', this.refresh, this, {destroyable: true});

        this.filterField.setFilter(location => view.supportsLocation(location));

        this.list.setGeographicRelease(SA.data.Vendors.getScarboroughCrosstabModel().getLatestGeographicRelease());

        this.refresh();
    }
});